import { chartColors } from "../../../reports/colors";

// Extracted from the identical processChartData() copy-pasted in
// DiamondReportsColorComp/SizeComp/PriceComp/ClarityComp.
export const DEFAULT_MAX_ENTRIES = 15;

export const bucketTopN = (
  list,
  { labelKey, valueKey, chartLabel, max = DEFAULT_MAX_ENTRIES, othersLabel }
) => {
  if (!list?.length) {
    return { chartData: [], colors: [], othersCount: 0 };
  }

  const filteredData = list.filter((item) => item[valueKey] > 0);
  const sortedData = [...filteredData].sort(
    (a, b) => b[valueKey] - a[valueKey]
  );

  const topData = sortedData.slice(0, max);
  const remainingData = sortedData.slice(max);

  const othersValue = remainingData.reduce(
    (sum, item) => sum + item[valueKey],
    0
  );
  if (othersValue > 0 && remainingData.length > 0) {
    topData.push({
      [labelKey]: othersLabel,
      [valueKey]: othersValue,
      isOthers: true,
    });
  }

  const total = topData.reduce((sum, item) => sum + item[valueKey], 0);

  const processedChartData = [[chartLabel, "Count"]];
  const colors = [];

  topData.forEach((item, index) => {
    const percentage =
      total > 0 ? ((item[valueKey] / total) * 100).toFixed(1) : 0;
    const color = item.isOthers
      ? "#CCCCCC"
      : chartColors[index % chartColors.length];
    colors.push(color);
    processedChartData.push([
      `${item[labelKey]} (${percentage}%)`,
      item[valueKey],
    ]);
  });

  return { chartData: processedChartData, colors, othersCount: remainingData.length };
};
